import React from 'react';
import { motion } from 'framer-motion';
export function WhatIsSection() {
  return <section className="py-24 px-6 max-w-4xl mx-auto text-center" data-id="element-150">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} data-id="element-151">
        <h2 className="text-3xl md:text-4xl font-serif text-brand-cream mb-8 flex items-center justify-center gap-3" data-id="element-152">
          <span className="text-brand-gold text-2xl" data-id="element-153">🌷</span>
          ¿Qué es "Atajo al Éxito"?
        </h2>

        <p className="text-lg md:text-xl text-brand-cream/80 font-light leading-relaxed mb-8" data-id="element-154">
          Es una mentoría intensiva y personalizada donde trabajaremos juntas:
        </p>

        <div className="flex flex-nowrap justify-center items-center gap-2 sm:gap-3 md:gap-4 mb-12 overflow-x-auto pb-2" data-id="element-155">
          {['Tu mentalidad', 'Tu estrategia', 'Tu marca personal', 'Tu negocio digital'].map((item, i) => <span key={i} className="shrink-0 px-3 sm:px-5 md:px-6 py-2 md:py-3 rounded-full border-2 border-brand-gold text-brand-cream font-medium tracking-wide text-[10px] sm:text-xs md:text-sm uppercase whitespace-nowrap shadow-sm bg-brand-brown-light/60" data-id="element-156">
              {item}
            </span>)}
        </div>

        <div className="bg-brand-brown-light/60 p-8 md:p-12 border border-brand-gold/20 shadow-sm rounded-2xl" data-id="element-157">
          <p className="text-2xl md:text-3xl lg:text-4xl font-serif text-brand-cream leading-relaxed" data-id="element-158">
            No será una mentoría genérica.
            <br data-id="element-159" />
            <br data-id="element-160" />
            <span className="italic text-brand-gold" data-id="element-161">
              Será un espacio real, humano y estratégico
            </span>{' '}
            para ayudarte a dejar el estancamiento y empezar a construir algo
            propio con dirección y estructura.
          </p>
        </div>

        <div className="mt-12" data-id="element-162">
          <a href="https://wa.me/message/LI4MMCWOOCMYN1" target="_blank" rel="noopener noreferrer" className="btn-gold-shine inline-block px-10 py-4 rounded-full uppercase tracking-widest text-sm font-semibold" data-id="element-163">
            Quiero mi mentoría ahora
          </a>
        </div>
      </motion.div>
    </section>;
}